'use strict';

angular.module('pmtPlacesApp.filters').filter('hour', function () {

	return function (input) {
		if (input && input.length === 4) {
			return input.substr(0, 2) + ':' + input.substr(2, 2);
		} else {
			return input;
		}
	};
});
